module.exports = __webpack_public_path__ + "static/about-us-17-8cfe772baf18dc13bbfd2fadecacd1bd.jpg";